import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { pointsService } from '../../services';
import { useAuth } from '../../contexts/AuthContext';
import type { PointsTransaction } from '../../types';
import styles from './History.module.css';

export const History: React.FC = () => {
  const { companyId } = useParams<{ companyId: string }>();
  const navigate = useNavigate();
  const { customer } = useAuth();
  const [transactions, setTransactions] = useState<PointsTransaction[]>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const cId = parseInt(companyId || '0');
  const card = customer?.loyaltyCards.find((c) => c.companyId === cId);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const response = await pointsService.getHistory(cId, page);
        setTransactions(response.data);
        setTotalPages(response.totalPages);
      } catch (err) {
        console.error('Errore caricamento storico:', err);
      } finally {
        setLoading(false);
      }
    };
    if (cId) load();
  }, [cId, page]);

  const formatDate = (dateStr: string) => {
    return new Date(dateStr).toLocaleString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <button className={styles.back} onClick={() => navigate('/')}>
          ← Indietro
        </button>
        <h1>Storico Punti</h1>
        {card && <p className={styles.balance}>Saldo: {card.pointsBalance} punti</p>}
      </header>

      {loading ? (
        <p className={styles.loading}>Caricamento...</p>
      ) : transactions.length === 0 ? (
        <p className={styles.empty}>Nessuna transazione</p>
      ) : (
        <>
          <div className={styles.list}>
            {transactions.map((tx) => (
              <div key={tx.id} className={styles.txRow}>
                <div className={styles.txInfo}>
                  <span className={styles.txDesc}>
                    {tx.description || tx.type}
                  </span>
                  <span className={styles.txMeta}>
                    {formatDate(tx.createdAt)}
                    {tx.siteName && ` · ${tx.siteName}`}
                  </span>
                </div>
                <span className={`${styles.txPoints} ${tx.points > 0 ? styles.positive : styles.negative}`}>
                  {tx.points > 0 ? '+' : ''}{tx.points}
                </span>
              </div>
            ))}
          </div>

          {totalPages > 1 && (
            <div className={styles.pagination}>
              <button disabled={page <= 1} onClick={() => setPage(page - 1)}>Precedente</button>
              <span>{page} / {totalPages}</span>
              <button disabled={page >= totalPages} onClick={() => setPage(page + 1)}>Successiva</button>
            </div>
          )}
        </>
      )}
    </div>
  );
};
